import {
    Component,
    EventEmitter,
    OnInit,
    TemplateRef,
    ViewChild,
} from "@angular/core";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import { COSMIC_THEME, NbDialogService, NbToastrService } from "@nebular/theme";
import { contributionRule } from "../../model/contribution-rule.model";
import { ApiService } from "../../services/api.service";
import { WalletService } from "../../services/wallet.service";
import * as listener from "../../../scripts/listener.js";
// import * as listener from "../../../../watcher/app/watcher.js";
import { environment } from "../../../environments/environment";

import { StageRules } from "../../model/stageRules.model";

@Component({
    selector: "ngx-contribute",
    templateUrl: "./contribute.component.html",
    styleUrls: ["./contribute.component.scss"],
})
export class ContributeComponent implements OnInit {
    public tokenReleaseForm: FormGroup;
    corruptedTx: any = [];
    userId;
    isMetamask = false;
    isWalletConnect = false;
    currentUserAddress;
    isInCollection = false;
    rulesPassed = false;
    blurred = "blur(0)";
    codeIsCorrect = false;
    isWhiteListed = false;
    isConnected = false;
    currentAddress;
    name: string;
    lname: string;
    email: string;
    txData: any;
    contributionAmount: number;
    errorMessage: string;
    public collectionsForm: FormGroup;
    currentUserBalance: any;
    foundTx: any;
    addressIds: any = [];
    minMaxContribError: boolean = false;
    currentTxHash: string = "";
    currentTxHashTxConfirmed = false;
    contributionRules: any;
    walletHasEnoughFunds = true;
    userContribAmount: any = 0;
    userContribArray: any;
    siteKey: any;
    minContrib: any;
    maxContrib: any;
    activeStage: any;
    constructor(
        private _nbDialogService: NbDialogService,
        private _apiService: ApiService,
        private _walletService: WalletService,
        private fb: FormBuilder,
        private toastrService: NbToastrService
    ) {
        this.collectionsForm = this.fb.group({
            name: ["", Validators.required],
            lname: ["", Validators.required],
            email: ["", Validators.email],
            contributionAmount: ["", Validators.required],
            // recaptcha: ["", Validators.required],
        });

        this.tokenReleaseForm = this.fb.group({
            walletAddress: ["", Validators.required],
        });
    }

    ngOnInit(): void {
        this.siteKey = environment.GOOGLE_RECAPTCHA_SITE_KEY;
        if (this._walletService.metamaskInstalled !== false) {
            this.getActiveStage();
            this.checkWhiteListStatus();
            this._walletService.checkWalletDisconnect();
            this.checkConnectionAddress();
            this.checkwalletConnection();
            this.incoming();
            this.updateState();
            this.getContributionAmountPerUser();
            this.getContributionData();
        } else {
            this.activeStage();
            this.getContributionAmountPerUser();
            this.checkWhiteListStatus();
            this.checkwalletConnection();
            this.checkConnectionAddress();
            this.incoming();
            this.updateState();
            this.getContributionData();
        }
    }
    getActiveStage() {
        this._apiService.getActiveStage(1).subscribe((res)=> {
            this.activeStage = res['uniqueID'];
        }) 
    }
    tokenRelease() {
        let tokenRelease = this._walletService.releaseTokensMetamask(
            this.tokenReleaseForm.controls["walletAddress"].value, this.activeStage
        );
    }
    updateState = async () => {
        setInterval(() => {
            this.getContributionAmountPerUser();
        }, 15000);
    };

    sendEmail = async () => {
        this._apiService.sendEmail("").subscribe((res) => {
        });
    };
    test = async () => {
        // listener.test();
    };
    getContributionAmountPerUser = async () => {
        this.userContribAmount = 0;
        this.currentAddress = await this._walletService.getAddress();
        if (Array.isArray(this.currentUserAddress)) {
            this.currentUserAddress = this.currentUserAddress[0];
        }
        let sum: any;
        let contributionAmount = this._apiService
        .getSumPerActiveStage(1).subscribe(async(res)=> {
            this.userContribAmount = res['totalAmount']
        })
    };
    getContributionData() {
        this._apiService
            .getStageRules(1) // Currently 1, will recive from db
            .subscribe((res) => {
                this.contributionRules = res['stageRules'];
            });
    }

    checkUserBalance = async (addr) => {
        // this.currentUserBalance = await listener.getBalance(this.currentUserAddress);
        // this._walletService.sendTransactionMetamask(this.currentUserAddress, String(100*(10**6))); // *10**6 is so that it places correct number of decimals.
        // this._apiService.sendEmail("").subscribe();
        // this.incoming();
        let tx = await this.sendTransaction(String(20 * 10 ** 18));
    };
    disconnectWalletConnect = async () => {
        await this._walletService.destroyConnectionWalletConnect();
    };

    checkWhiteListStatus = async () => {
        // this.currentAddress = await this._walletService.getAddress();
        this.currentAddress = await this.getUserAddress();

        // this.currentAddress = "0xBc41be112E9d028FfA404e55f09EeDf80673736D";
        // if(this.currentAddress == false){
        //   this.currentAddress = await this.currentUserAddress;
        // }
        this.currentAddress = this.currentUserAddress;
        if (this.currentAddress !== undefined && this.currentAddress) {
            //  && this.isConnected == false Add this in case of erros
            this._apiService
                .getWhiteListStatus(1, this.currentAddress)
                .subscribe((res) => {
                    let data = res;
                    if (data["isWhitelisted"] == true) {
                        this.isWhiteListed = true;
                    } else {
                        this.isWhiteListed = false;
                    }
                });
            // } else {
            //     this.currentAddress =
            //         await this._walletService.getCryptoComAddress();
            //     if (this.currentAddress !== undefined) {
            //         //  && this.isConnected == false Add this in case of errors
            //         this.isConnected = true;
            //         this._apiService
            //             .getCurrentWhiteListStatus(
            //                 "?filters[address][$eq]=" +
            //                 this.currentAddress[0].toLowerCase()
            //             )
            //             .subscribe((res) => {
            //                 let data = res["data"];
            //                 if (data[0]["attributes"].Tier == "Seed") {
            //                     this.isWhiteListed = true;
            //                 } else {
            //                     this.isWhiteListed = false;
            //                 }
            //             });
            //     }
        }
    };
    async checkContributionRules(currentAddress, amountContributed) {
        // TODO: ADD check for canBuyAgain
        // let rules: contributionRule;
        // let collection = this._apiService
        //     .getCollection(
        //         "?filters[ContributionWallet][$eq]=" + currentAddress
        //     )
        //     .subscribe((res) => {
        //         if (res["data"][0] !== undefined) {
        //             if (
        //                 res["data"][0]["attributes"].ContributionWallet !== " "
        //             ) {
        //                 this.isInCollection = true;
        //             } else {
        //                 this.isInCollection = false;
        //             }
        //         }
        //     });
        // if (!this.isInCollection) {
        // CHANGE TO NOT IN COLLECTION TO ONLY ALLOW EACH WALLET TO CONTRIBUTE ONCE!
        // let minimumData = await this.contributionRules[0]['attributes'].minimumAmount // For prod
        // let maximumData = await this.contributionRules[0]['attributes'].maximumAmount // For Prod

        let minimumData = this.contributionRules.minContribution;
        let maximumData = this.contributionRules.maxContribution;
        if (
            amountContributed >= minimumData &&
            amountContributed <= maximumData
        ) {
            // this.setRulesPassed(true);
            // if (amountContributed <= await this.contributionRules[0]['attributes'].totalSupply) {
            if (amountContributed <= maximumData) {
                this.setRulesPassed(true);
                this.minMaxContribError = false;
            } else {
                this.setRulesPassed(false);
            }
        } else {
            this.setRulesPassed(false);
            this.minMaxContribError = true;
        }
        // }
    }
    setRulesPassed(bool) {
        this.rulesPassed = bool;
    }
    setMinMaxError = async (bool) => {
        this.minMaxContribError = bool;
    };
    corruptTransactions = async (corruptedData) => {
        setTimeout(async () => {
            for (let item in await corruptedData) {
                this._apiService
                    .corruptTransaction(corruptedData[item].id)
                    .subscribe();
            }
        }, 500);
    };
    incoming = async () => {
        setInterval(async () => {
            // Fetch all incoming transactions

            this._apiService.getSubmittedTx().subscribe(async (res) => {
                this.txData = res;

                listener.getTransaction(await this.txData).then((res) => {
                    this.foundTx = res.foundTx;
                    this.corruptedTx = res.corrutpedTx;

                    // Call the listener with tx array of objects so it tries to find them on block
                });

                // All found tx are hosted inside foundArray
                // let foundArray = this.foundTx;
                // Address array hosts all addresses of found tx
                let addressArray = [];
                setTimeout(async () => {
                    // addressArray = await this.foundTx;

                    if (
                        (await this.foundTx) !== undefined &&
                        (await this.foundTx.length) !== 0
                    ) {
                        for (let item in await this.foundTx) {
                            addressArray.push(this.foundTx[item]);
                        }

                        // TIMEOUT TO BE REMOVE, Only reason for this timeout was due to web3.js not working properly with promises, and it would return empty result before it was over, 500ms is not needed, but i've placed 500 ms just to be safe.
                        setTimeout(async () => {
                            //('/?filters[txHash][$in]=' +

                            if ((await addressArray.length) !== 0) {
                                // Get list of tx based on found addresses
                                this._apiService
                                    .getListOfTx(addressArray)
                                    .subscribe(async (res) => {
                                        let data = res;
                                        // Get their id so they can be updated appt
                                        for (let item in data) {
                                            // this.addressIds.push(data[item]["uniqueID"]);
                                            this._apiService
                                                .updateTransactionSetConfirmed(
                                                    await data[item][
                                                        "uniqueID"
                                                    ],
                                                    "confirmed"
                                                )
                                                .subscribe();
                                        }
                                    });

                                // For each item(id) Update it.
                                // Strapi doesn't currently support out of the box bulk update, thats why update is inside for loop (I am aware that this is bad practice.)
                                // There is probably a better way to do this, ask Boss to find a better solution to most of this code, currently under time pressure.
                                for (let item in await this.addressIds) {
                                }
                            }
                            // Set transactions status to corrupted (Created  new function to not add even more code here.)

                            this.corruptTransactions(await this.corruptedTx);

                            // Reset address ids after everything is done.
                            this.addressIds = [];
                        }, 500);
                    }
                }, 500);
            });
        }, 60000); // Set to 60000 for 1 minute
    };

    async checkIfTxProcessed(txHash) {
        let listenerCondition: any = await listener.getSingleTransaction(
            txHash
        );
        if (listenerCondition === true) {
            this._apiService
                .getTransactions("/?filters[txHash][$eq]=" + txHash)
                .subscribe(async (res) => {
                    let data = res["data"];
                    if (data) {
                        this._apiService
                            .updateTransaction(data[0]["id"])
                            .subscribe();
                    }
                });
        }
    }
    watchForTxConfirm = async () => {
        const interval = setInterval(async () => {
            if (await listener.getSingleTransaction(this.currentTxHash)) {
                this.toastrService.show("Your transaction has been processed.");
                clearInterval(interval);
            } else {
            }
        }, 500);
    };
    async testCheckTokenName() {
        let logs = await listener.getBalanceNoContract(this.currentUserAddress);
    }
    async checkTx() {
        let tx = await listener.getSingleTransaction(
            "0x40624c1955f12b3ef925e7caebf6d97f615f6b654c5d8c86b1077c8194605b71"
        );
    }

    async insertCollectionForm() {
        if (this.formIsValid()) {
            await this.checkConnectionAddress();
            await this.checkwalletConnection();
            let data = {};
            this.name = this.collectionsForm.get("name")?.value;
            this.lname = this.collectionsForm.get("lname")?.value;
            this.email = this.collectionsForm.get("email")?.value;
            this.contributionAmount =
                this.collectionsForm.get("contributionAmount")?.value;
            data["name"] = this.name;
            data["last_name"] = this.lname;
            data["Email"] = this.email;
            data["ContributionWallet"] = this.currentUserAddress;
            data["ContributionAmount"] = this.contributionAmount;

            // let userBalance = await listener.getBalanceNoContract(this.currentUserAddress);
            let userBalance = await this._walletService.getBalanceUsdc(
                this.currentUserAddress
            );
            // let userBalance = 100;
            let contributed: any = this.contributionAmount;
            await this.checkContributionRules(
                this.currentAddress,
                await contributed
            );
            setTimeout(async () => {
                if (this.rulesPassed) {
                    if ((await userBalance) >= contributed) {
                        this.walletHasEnoughFunds = true;
                        if (this.currentAddress == undefined) {
                            this.currentAddress = this.currentUserAddress[0];
                        }
                        let txHash = await this.sendTransaction(
                            String(this.contributionAmount * 10 ** 18)
                        );
                        if (txHash) {
                            let customBuiltNumber =
                                "0.0" + this.contributionRules.seedPrice;
                            let txData = {
                                crowdsaleID: 1,
                                walletAddress: this.currentAddress,
                                txHash: txHash,
                                amount: this.contributionAmount,
                                amountInCustomToken:
                                    this.contributionAmount /
                                    parseFloat(customBuiltNumber),
                            };
                            this._apiService
                                .insertTransaction(txData)
                                .subscribe();
                            // this._apiService
                            //     .insertCollections(data)
                            //     .subscribe();
                            // this._apiService
                            //     .sendEmail(this.email, this.contributionAmount)
                            //     .subscribe();
                            this.toastrService.show(
                                "You have successfully submited a transaction!"
                            );
                            // setTimeout(() => {
                            //   location.reload();
                            // }, 2000)
                        }
                    } else {
                        console.log("Your wallet does not have enough money.");
                        this.rulesPassed = false;
                        this.walletHasEnoughFunds = false;
                    }
                } else {
                    await this.checkContributionRules(
                        this.currentAddress,
                        await contributed
                    );
                }
            }, 100);
            // }
        }
    }

    // If user clicks button, form gets checked and shows appt messages if invalid.
    formIsValid() {
        if (this.collectionsForm.valid) {
            return true;
        } else {
            Object.keys(this.collectionsForm.controls).forEach((field) => {
                const control = this.collectionsForm.get(field);
                control.markAsTouched({ onlySelf: true });
            });
            return false;
        }
        return true;
    }

    checkConnectionAddress = async () => {
        if ((await this._walletService.getAddress()) === undefined) {
            this.currentUserAddress =
                await this._walletService.getCryptoComAddress();
        } else {
            this.currentUserAddress = await this._walletService.getAddress();
        }
    };
    getUserAddress = async () => {
        if (this._walletService.checkMetmaskInstalled() == false) {
            this.currentUserAddress =
                await this._walletService.getCryptoComAddress();
        } else {
            this.currentUserAddress = await this._walletService.getAddress();
        }
    };
    checkwalletConnection = async () => {
        if ((await this._walletService.getAddress()) !== undefined) {
            this.isMetamask = true;
            this.isWalletConnect = false;
            this.isConnected = true;
        } else if (
            (await this._walletService.getCryptoComAddress()) !== undefined
        ) {
            this.isWalletConnect = true;
            this.isMetamask = false;
            this.isConnected = true;
        } else {
            this.isConnected = false;
        }
    };

    sendTransaction = async (contributionAmount) => {
        if (this.isMetamask && !this.isWalletConnect) {
            let txHash = await this._walletService.sendTransactionMetamask(
                this.currentAddress,
                contributionAmount
            );
            // let txHash = await this._walletService.releaseTokensMetamask();
            return txHash;
            // await listener.getTransaction(txHash);
        } else if (!this.isMetamask && this.isWalletConnect) {
            let txHash = await this._walletService.sendTransactionWalletConnect(
                this.currentUserAddress,
                contributionAmount
            );
            return txHash;
        } else {
            return false;
        }
    };

    //   ngAfterViewInit() : void{
    //     if(!this.codeIsCorrect){
    //     // DO NOT REMOVE THE TIMER! DO NOT CHANGE THE 1 MS, WITHOUT IT DIALOG DOESNT WORK!
    //     setTimeout(()=> {this.openDialog()},1) // Dialog didnt want to render on load with everything I've tried(Tried a lot of things.) -- apparently 1 ms delay is enough time for everything to load.
    //     // this.openDialog();
    //     }
    //     else{
    //       // localStorage.clear();
    //       this.blurred = "blur(0)"
    //     }
    //   }
    //   openDialog = () => {
    //     this._nbDialogService.open(CollectionsDialogComponent, {closeOnBackdropClick: false, hasBackdrop:true})
    //   }
}
